import { useNavigate, useParams } from 'react-router-dom';
import { Row, Space } from 'antd';
import SearchBar from 'components/new-ui/base/searchbar/SearchBar';
import { CustomerSortParameter } from 'store/customers/customer';
import { getTableChangeParams, SortDirections } from 'utils/tableHelpers';
import { useRequestPromise } from 'hooks/useRequest';
import useCustomersFilters from 'views/customers/hooks/useCustomersFilters';
import CustomersTable from 'views/customers/components/customers-table/CustomersTable';
import { listCustomersOfTeam } from 'store/teams/client';

/**
 * Note: Currently there are no customers that are in a relation with the team.
 * We display the customers that are used in declarations related to the team,
 * but these are not separate customers - these are the customers for the tenant.
 *
 * For this reason, we decided to hide the actions column since archiving/updating customer here
 * would update the customer for the tenant (and for all teams)
 *
 */
const PartiesTab = () => {
    const navigate = useNavigate();
    const { teamId } = useParams();
    const { appliedParams, setQueryInputVal, queryInputVal, setPage, setSize, setSortState } = useCustomersFilters();

    const { data, isLoading } = useRequestPromise(
        () => {
            if (!teamId) return null;
            return listCustomersOfTeam(teamId, appliedParams);
        },
        {},
        [appliedParams]
    );

    const { page, size } = appliedParams;

    return (
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
            <Row>
                <Space size={8}>
                    <SearchBar
                        inputPlaceholder="Seach Parties"
                        value={queryInputVal}
                        onSearch={(val) => {
                            setQueryInputVal(val);
                            setPage(0);
                        }}
                        onClear={() => {
                            setQueryInputVal('');
                            setPage(0);
                        }}
                    />
                </Space>
            </Row>

            <CustomersTable
                loading={isLoading}
                customers={data?.list || []}
                onChange={(antPagination, _filters, sorter) => {
                    const raw = getTableChangeParams({ pagination: antPagination, sorter });

                    const { page, size, sortParameter, sortDirection } = (raw || {}) as {
                        page?: number;
                        size?: number;
                        sortParameter?: string;
                        sortDirection?: SortDirections;
                    };

                    setPage((p) => (typeof page === 'number' ? page : p));
                    setSize((p) => (typeof size === 'number' ? size : p));

                    if (!sortParameter || !sortDirection) {
                        setSortState({ sort: undefined, sortDirection: undefined });
                    } else {
                        setSortState({
                            sort: sortParameter as CustomerSortParameter,
                            sortDirection: sortDirection as SortDirections,
                        });
                    }
                }}
                pagination={{
                    current: (typeof page === 'number' ? page : 0) + 1,
                    pageSize: size,
                    total: data?.total,
                    position: ['bottomCenter'],
                    showSizeChanger: true,
                    hideOnSinglePage: true,
                }}
                onRow={(record) => {
                    return {
                        style: { cursor: 'pointer' },
                        onClick: () => navigate(`/customers/${record.id}`),
                    };
                }}
            />
        </Space>
    );
};

export default PartiesTab;
